<template>
<div>
    <Header />
    
    <div v-if="$parent.updated" class="updated-message card-shadow">
        <div style="width: 400px; text-align: center; margin-bottom: 30px; margin-top: 40px;">
            <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(2.0);">
                <path d="M16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32ZM13 19.4L23 10C23.5 9.5 24.3 9.5 24.8 10C25.3 10.5 25.3 11.2 24.8 11.7L13.9 22C13.7 22.2 13.3 22.3 13 22.3C12.7 22.3 12.3 22.2 12.1 22L7.1 17.4C6.6 16.9 6.6 16.2 7.1 15.7C7.6 15.2 8.4 15.2 8.9 15.7L13 19.4Z"/>
            </svg>
        </div>
        <div style="width: 400px; text-align: center; font-size: 18px;">
            <p>Fraktavtalen er oppdatert.</p>
            <p>Du kan nå lukke fanen.</p>
        </div>
    </div>

    <div v-if="!loading" class="form-container">
        <vm-form>

            <vm-card list :header="__('company')">
                <vm-row>
                    <vm-group c6>
                        <vm-label :text="__('company_name')" />
                        <vm-input v-model="customer.name" maxbo disabled />
                    </vm-group>
                    <vm-group c3>
                        <vm-label :text="__('org_number')" />
                        <vm-input v-model="customer.orgnr" maxbo disabled />
                    </vm-group>
                    <vm-group c3>
                        <vm-label :text="__('customer_number')" />
                        <vm-input v-model="customer.number" maxbo disabled />
                    </vm-group>
                </vm-row>
            </vm-card>

            <vm-card v-if="!$parent.updated" list :header="'Hva vil du gjøre?'">
                <vm-row style="padding: 20px 40px;">
                    <vm-group c4>
                        <vm-button :text="'Last ned fraktavtale'" :icon="'download'" @clicked="onDownloadClicked" />
                    </vm-group>
                    <vm-group c4>
                        <vm-button :text="'Vis fraktavtale'" :icon="'preview'" @clicked="onPreviewClicked" />
                    </vm-group>
                    <vm-group c4>
                        <vm-button :text="'Endre fraktavtale'" :icon="'edit'" @clicked="onEditClicked" />
                    </vm-group>
                </vm-row>
            </vm-card>

            <vm-card v-if="$parent.updated" list :header="'Hva vil du gjøre?'">
                <vm-row style="padding: 20px 40px;">
                    <vm-group c6>
                        <vm-button :text="'Last ned fraktavtale'" :icon="'download'" @clicked="onDownloadClicked" />
                    </vm-group>
                    <vm-group c6>
                        <vm-button :text="'Vis fraktavtale'" :icon="'preview'" @clicked="onPreviewClicked" />
                    </vm-group>
                </vm-row>
            </vm-card>

        </vm-form>
    </div>

    <ve-preview-popup v-if="previewPopup" :blob="previewData" :filename="filename" @close="previewPopup = false" />

    <div v-if="previewDownloading" class="main-spinner card-shadow">
        <Spinner :text="'Lager fraktavtale...'" />
    </div>

</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import downloadjs from 'downloadjs'
import maxbo from '../maxbo';
import log from '../log';
import shippingapi from '../shippingapi';

import Header from '../components/nav/Header';
import Spinner from '../components/nav/Spinner';
import VueCookies from 'vue-cookies';
import Vue from 'vue';

export default {
name: 'Home',
components: {
    Header,
    Spinner
},
data() {
    return {
        loading: true,
        customer: {},
        shipping: {},
        previewPopup: false,
        previewData: '',
        filename: '',
        previewDownloading: false,
	    additionalInfo: ''
    }
},
methods: {
    async onDownloadClicked() {
        this.previewDownloading = true;
        if (this.previewData == '') {
            const pdfStrings = shippingapi.getPDFValues(this.shipping, this.$parent.sheetData.values);
            const response = await maxbo.generatePDF(this.$root.translations, this.customer, pdfStrings, this.additionalInfo);
            this.previewData = response.data;
        }
        downloadjs("data:application/pdf;base64," + this.previewData, this.filename + ".pdf", "application/pdf");
        this.previewDownloading = false;
    },
    async onPreviewClicked() {
        this.previewDownloading = true;
        if (this.previewData == '') {
            const pdfStrings = shippingapi.getPDFValues(this.shipping, this.$parent.sheetData.values);
            console.log('pdf', pdfStrings);
            const response = await maxbo.generatePDF(this.$root.translations, this.customer, pdfStrings, this.additionalInfo);
            this.previewData = response.data;
        }
        this.previewPopup = true;
        this.previewDownloading = false;
    },
    onEditClicked() {
        this.$parent.navigate({
            path: '/shipping', 
            query: this.$route.query
        });
    }
},
async created() {
	
	Vue.use(VueCookies);
	$cookies.config('365d');
	this.additionalInfo = $cookies.get('additionalInfo') || '';
	
    this.$parent.setLoading(true, 'Henter kunde fra SuperOffice...');

    this.customer = await this.$parent.getCustomer();
    this.filename = 'Fraktavtale ' + this.customer.name;

    this.$parent.setLoading(true, 'Henter data fra frakt-tabellen...');

    this.shipping = await this.$parent.getShipping();

    // Prepare shipping object
    shippingapi.setMaxDiscounts(this.shipping, this.$parent.sheetData.values);
    shippingapi.setOriginalPrices(this.shipping, this.$parent.sheetData.values);
    
    this.loading = false;
    this.$parent.setLoading(false);
}
}
</script>
<style scoped>

.updated-message {
    width: 400px;
    padding: 10px 0px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: -30px;
    border-radius: 5px;
    background-color: white;
}
.updated-message path {
    fill: #004976;
}

</style>